import { SidePanelHandler as BaseSidePanelHandler } from '@theia/core/lib/browser/shell/side-panel-handler';
import { Panel } from '@theia/core/shared/@lumino/widgets';
import { inject, injectable } from '@theia/core/shared/inversify';
import { LeftPanelContribution } from './left-panel-contribution';
import { RightPanelContribution } from './right-panel-contribution';

@injectable()
export class AppSidePanelHandler extends BaseSidePanelHandler {
    @inject(LeftPanelContribution)
    protected readonly leftPanelContribution!: LeftPanelContribution;

    @inject(RightPanelContribution)
    protected readonly rightPanelContribution!: RightPanelContribution;

    protected override createContainer(): Panel {
        if (this.side === 'right') {
            return this.rightPanelContribution.createContainer(this);
        } else {
            return this.leftPanelContribution.createContainer(this);
        }
    }

    getLastActiveTabIndex(): number | undefined {
        return this.state.lastActiveTabIndex;
    }

    protected getDefaultPanelSizeForRight(): number | undefined {
        return this.rightPanelContribution.getDefaultPanelSize(this);
    }

    protected override getDefaultPanelSize(): number | undefined {
        if (this.side === 'right') {
            return this.getDefaultPanelSizeForRight();
        }
        return super.getDefaultPanelSize();
    }

    override refresh(): void {
        if (this.side === 'right') {
            super.refresh();
            this.rightPanelContribution.afterRefresh(this);
            return;
        }

        this.leftPanelContribution.beforeRefresh(this);
        super.refresh();
    }
}
